import ChecklistBuilderModule from './ChecklistBuilder';
import { Module } from './types';

const modules: Module[] = [ChecklistBuilderModule];

export default modules;
